<template>
    <div class="licensed-insured">
        <div class="title-section">
            <div class="title">
                <span class="star">★ 
                </span>
                <h3 class="title-message">Your Peace of Mind: Licensed and Insured</h3>
            </div>
                <ul class="facts">
                    <li>
                        <span class="little-star">★</span> <span>Licensed by the State of Michigan (License #252400025)</span>
                    </li>
                    <li>
                        <span class="little-star">★</span> <span>Maintains $1,000,000 in general liability insurance</span>
                    </li>
                    <li>
                        <span class="little-star">★</span> <span>Certificates of insurance available upon request</span>
                    </li>
                </ul>
            
            <div class="title">
                <span class="star">★ </span><h3 class="title-message">Beyond licensing and insurance, we are committed to:</h3>
            </div>
                
                <ul class="facts">
                    <li>
                        <span class="little-star">★</span> <span>Providing high-quality materials and workmanship</span>
                    </li>
                    <li>
                        <span class="little-star">★</span> <span>Offering free estimates and competitive pricing</span>
                    </li>
                    <li>
                        <span class="little-star">★</span> <span>Ensuring customer satisfaction with every project</span>
                    </li>
                </ul>

            <div class="title">
                <span class="star">★ </span><h3 class="title-message">Verify Our Credentials</h3>
             </div>
            <div class="sub-title">
            </div>
            <ul class="facts">
                    <li>
                        <span class="little-star">★</span> <span class="long-message">Our credentials can be easily verified on the <a href="https://aca-prod.accela.com/LARA/GeneralProperty/LicenseeDetail.aspx?LicenseeNumber=252400025&LicenseeType=Residential+Builder+M+and+A+Individual" target="_blank" rel="noopener">Michigan Department of Licensing and Regulatory Affairs (LARA) website</a>.</span>
                    </li>
                    <li>
                        <span class="little-star">★</span> <span class="long-message">Our reputation speaks for itself: Read <a href="https://g.co/kgs/2RgTJDy" target="_blank" rel="noopener">testimonials</a> from homeowners we've served.</span>
                    </li>

                </ul>
        </div>


    </div>
</template>

<style scoped>
.licensed-insured {
  font-family: 'Roboto', sans-serif;
  background: transparent;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
}
.title-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.title {
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-size: 1.5em; /* Adjust font size as needed */
  color: #ffffff; /* White text */
  text-shadow: 2px 2px 0px #000000;
  letter-spacing: 2px;
  padding: 0 20px;
} 
.title-message {
  margin-left: 5px; /* Space between star and text */
  font-size: 1em; /* Adjust font size as needed */
  color: #ffffff; /* White text */
  text-shadow: 2px 2px 0px #000000;
    letter-spacing: 2px;
}
.facts {
  margin-left: 20px;
  margin-top: 0px;
  color: #ffffff;
  display: flex;
  line-height: 1.5em;
  font-size: 1.2em;
  text-shadow: 2px 2px 0px #000000;
  letter-spacing: 2px;
  font-family: 'Roboto', sans-serif;
  flex-direction: column;
  align-items: flex-start;
  text-wrap: pretty;
}
@media screen and (max-width: 600px) {
    .facts {
        margin-left: 0;
        font-size: .9em;
        letter-spacing: 0;
    }
  }
  .long-message {
    font-size: .9em; /* Adjust font size as needed */
    color: #ffffff; /* White text */
    margin-left: 5px;  
  } 

.star {
  color: #f1c40f; /* Gold color for the star */
  font-size: 45px; /* Adjust size as needed */
  margin-right: 5px; /* Space between star and text */
}
@media screen and (max-width: 600px) {
    .star {
        display: none;
    }
    
}
.little-star {
  color: #f1c40f; /* Gold color for the star */
  font-size: 25px; /* Adjust size as needed */
  margin-right: 5px; /* Space between star and text */
}
.facts li {
    text-align: left;
    margin-bottom: 10px; /* Space between each item */
    list-style: none;
}
.facts li a {
        color: #f1c40f;
    text-decoration: none;
    font-weight: bold;
    text-shadow: none;
}
.facts li a:hover {
    color: #ffd84d;
  text-decoration: underline; /* Underline for links */
}
</style>

<script>
export default {
    name: 'LicensedInsured'
}
</script>
